var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('navbar',[_c('div',{staticClass:"prise_rv"},[_c('step-prive-rv',{attrs:{"doctor":_vm.doctor,"date-select":_vm.dateSelect}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }